import * as React from 'react';
import { forwardRef } from 'react';
import { c as createNolIcon } from '../utils/index.js.mjs';

function SvgIcVisibilityon(props, ref) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: "24",
    height: "24",
    fill: "none",
    viewBox: "0 0 24 24",
    ref: ref
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M12 7.25a4.25 4.25 0 1 0 0 8.5 4.25 4.25 0 0 0 0-8.5M9.25 11.5a2.75 2.75 0 1 1 5.5 0 2.75 2.75 0 0 1-5.5 0",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M12 4.5c-4.276 0-8.616 2.663-10.012 6.211a2.24 2.24 0 0 0 0 1.64C3.384 15.9 7.724 18.562 12 18.562c4.275 0 8.616-2.663 10.012-6.21a2.24 2.24 0 0 0 0-1.64C20.616 7.162 16.275 4.5 12 4.5m-8.617 6.76C4.517 8.382 8.232 6 12 6s7.483 2.381 8.616 5.26a.74.74 0 0 1 0 .542c-1.133 2.88-4.848 5.26-8.616 5.26s-7.483-2.38-8.617-5.26a.74.74 0 0 1 0-.541",
    clipRule: "evenodd"
  }));
}
var IcVisibilityon = createNolIcon(/*#__PURE__*/forwardRef(SvgIcVisibilityon));

export { IcVisibilityon as I };
